// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5e259d15","455":"9aa2bc2a","977":"39272ea5"}[chunkId] + ".chunk.js";
};